import { render, staticRenderFns } from "./AppDashboardIcon.vue?vue&type=template&id=046e2352"
import script from "./AppDashboardIcon.vue?vue&type=script&lang=js"
export * from "./AppDashboardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports